import styled from 'styled-components'

// Page preview - A4 aspect ratio for cover and last pages
// A4 dimensions: 210mm x 297mm (aspect ratio 0.707)
export const PagePreview = styled.div`
  width: 100%;
  aspect-ratio: 0.707;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;
`

// Section page preview - no aspect ratio, grows with content
export const SectionPagePreviewContainer = styled.div`
  width: 100%;
  min-height: calc(100vw * 1.414); /* Minimum A4 height */
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`

export const CoverContent = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
`

export const SectionContent = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
`

export const LastPageContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 32px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const SectionHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border.light};
`

export const ChipContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin: 12px 0;
`

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  background: linear-gradient(
    135deg,
    rgba(0, 173, 230, 0.08) 0%,
    rgba(0, 173, 230, 0.12) 100%
  );
  border: 1px solid rgba(0, 173, 230, 0.2);
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 173, 230, 0.1);
  font-size: 10px;
  font-weight: 600;
  color: #0099cc;
`

export const ChartPreviewContainer = styled.div`
  width: 100%;
  margin: 12px 0;
`
